// extracted by mini-css-extract-plugin
module.exports = {"input_group":"ToggleNumberInput_input_group__1wkB8"};